// ============================================================================
// FNE-BRIDGE Frontend - Service Notifications
// ============================================================================

import apiClient from './apiClient';
import type { ApiResponse, PaginatedResponse } from '../types/api';
import type { Notification } from '../types/models';

const BASE = '/notifications';

export const notificationService = {
  list: (params?: { page?: number; limit?: number }) =>
    apiClient.get<ApiResponse<{ notifications: Notification[]; unread_count: number }>>(BASE, { params }),

  markAsRead: (id: string) =>
    apiClient.post<ApiResponse<{ message: string }>>(`${BASE}/${id}/read`),

  markAllAsRead: () =>
    apiClient.post<ApiResponse<{ message: string }>>(`${BASE}/read-all`),
};
